/** Parse CHAT_MARKDOWN_ENABLED user setting; default is enabled. */
export function parseChatMarkdownEnabled(value) {
  if (value === false || value === 'false' || value === '0' || value === 0) return false;
  if (value === true || value === 'true' || value === '1' || value === 1) return true;
  return true;
}
